export enum EnumSiaqs {
    Resultado_Siaqs = 0,
    Motivo_Reprovacao_Siaqs = 1,
}
